module.exports = __webpack_public_path__ + "assets/img/btn-view-f935cded.png";